import React, { FC } from 'react';
import { useForm } from 'react-hook-form';
import { useParams } from 'react-router-dom';

import { useModal } from 'store/modal';
import { useActiveClientContext } from 'store/active-client';

import { buildClientEntity, buildClientUrl } from 'utils/helpers/client';
import UpdateEntity from 'components/crud/UpdateEntity';
import FieldForm from './FieldForm';
import { IField, IDropdowns } from '../types';

interface IProps {
  fieldsEntityName: string;
  field: IField;
  fieldDataOptions: IDropdowns;
}

const EditForm: FC<IProps> = ({ fieldsEntityName, field, fieldDataOptions }: IProps) => {
  const { id } = useParams<{ id: string }>();
  const { showModal } = useModal();
  const { client } = useActiveClientContext();

  const isMultilingual = client?.is_multilingual;

  const typeGroup = fieldDataOptions?.types.find(group => group?.options?.find(option => field!.type === option.value));

  const type = typeGroup?.options?.find(opt => field!.type === opt.value);

  const methods = useForm({
    defaultValues: {
      ...field,
      type,
      default_value: fieldDataOptions?.default_options.find(opt => field!.default_value === opt.value),
      identifier: fieldDataOptions?.identifiers.find(opt => field!.identifier === opt.value),
      hidden_identifier: fieldDataOptions?.hidden_identifiers.find(opt => field!.hidden_identifier === opt.value),
      mass_doc_behavior: fieldDataOptions?.mass_doc_behavior.find(opt => field!.mass_doc_behavior === opt.value),
      options: field?.options?.map(opt => ({
        label: opt.value.toString(),
        value: opt.value.toString(),
      })),
      ...(isMultilingual && {
        options_en: field?.options_en?.map((opt: any) => ({
          label: opt.value.toString(),
          value: opt.value.toString(),
        })),
      }),
    },
  });
  return (
    <UpdateEntity
      id={id}
      entity={fieldsEntityName}
      methods={methods}
      onSuccess={(res: any) => {
        const { name } = res.data;
        showModal({
          type: 'success',
          content: (
            <>
              Редактирахте поле&nbsp;
              <span className="font-weight-bold">{name}</span>.
            </>
          ),
        });
      }}
      queryKey={[buildClientEntity(fieldsEntityName, client), { id }]}
      onSuccessPushToLink={buildClientUrl('/fields', client)}
    >
      {(update: any) => (
        <FieldForm
          methods={methods}
          handleSubmit={data => {
            const formatData = {
              ...data,
              type: data.type.value,
              default_value: data.default_value?.value || null,
              identifier: data.identifier?.value || null,
              hidden_identifier: data.hidden_identifier?.value || null,
              mass_doc_behavior: data.mass_doc_behavior?.value || null,
              options: data.options?.map(opt => opt.value.toString()),
              ...(isMultilingual && {
                options_en: data.options_en?.map((opt: any) => opt.value.toString()),
              }),
              ...(data.type.value === 'numeric-integer' && {
                min_length: data.min_length || 0,
              }),
            };
            return update(formatData);
          }}
          btnLabel="Запази"
          fieldDataOptions={fieldDataOptions}
          canEdit={field.can_edit}
          isMultilingual={isMultilingual}
        />
      )}
    </UpdateEntity>
  );
};

export default EditForm;
